import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../common_types";

import { MarketsActionTypes } from "./types";

export const marketsFetchRequest = (payload: GatePayload) => action(MarketsActionTypes.FETCH_REQUEST, payload);

export const marketsFetchSuccess = (payload: { items: string[] }) => action(MarketsActionTypes.FETCH_SUCCESS, payload);

export const marketsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(MarketsActionTypes.FETCH_ERROR);
};
